module.exports = __webpack_public_path__ + "media/components/country-flag/static/ao-3c085e905b312bbc8e85beecb015bb94.svg";